import { render, staticRenderFns } from "./GroupsProgramDetails.vue?vue&type=template&id=de0b2a50&scoped=true&"
import script from "./GroupsProgramDetails.vue?vue&type=script&lang=ts&"
export * from "./GroupsProgramDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0b2a50",
  null
  
)

export default component.exports